/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserImportResponse
 */
export interface UserImportResponse {
    /**
     * 
     * @type {string}
     * @memberof UserImportResponse
     */
    correlationId?: string;
    /**
     * 
     * @type {any}
     * @memberof UserImportResponse
     */
    acceptedCount?: any | null;
}

/**
 * Check if a given object implements the UserImportResponse interface.
 */
export function instanceOfUserImportResponse(value: object): value is UserImportResponse {
    return true;
}

export function UserImportResponseFromJSON(json: any): UserImportResponse {
    return UserImportResponseFromJSONTyped(json, false);
}

export function UserImportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserImportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
        'acceptedCount': json['acceptedCount'] === undefined ? undefined : json['acceptedCount'] === null ? null : json['acceptedCount'],
    };
}

export function UserImportResponseToJSON(json: any): UserImportResponse {
    return UserImportResponseToJSONTyped(json, false);
}

export function UserImportResponseToJSONTyped(value?: UserImportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'correlationId': value['correlationId'],
        'acceptedCount': value['acceptedCount'],
    };
}

